/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export function getUrlParam(name, url) {
  let results = new RegExp('[?&]' + name + '=([^&#]*)').exec(url ? url : window.location.search)
  if (results === null) {
    return null
  } else {
    return decodeURI(results[1]) || 0
  }
}

export function dispatchMouseEvent(x, y) {
  const ev = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
    screenX: x,
    screenY: y
  })
  const el = document.elementFromPoint(x, y)
  el?.dispatchEvent(ev)
}

export function getCookie(cookieName) {
  const name = cookieName + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let c of ca) {
    c = c.trim()
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function capitalizeString(str) {
  return str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : str
}

export function getNumberOfDecimals(num) {
  const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)
  if (!match) return 0
  return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0))
}

export function getModalWindowTemplateUrl(type) {
  const PATH_TO_TEMPLATES = 'app/template/modal/'
  switch (type) {
    case 'draggable':
      return PATH_TO_TEMPLATES + 'draggable.modal.window.template.html'
    default:
      return PATH_TO_TEMPLATES + 'default.modal.window.template.html'
  }
}

export function getSizeOfObject(obj) {
  return Object.keys(obj).length
}

export function detectBrowser() {
  const isOpera =
    (typeof window !== 'undefined' && 'opr' in window && !!window.opr && !!window.opr.addons) ||
    !!window.opera ||
    navigator.userAgent.indexOf(' OPR/') >= 0
  const isFirefox = typeof window.InstallTrigger !== 'undefined'
  const isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === '[object SafariRemoteNotification]'
    })(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification))
  const isIE = !!document.documentMode
  const isEdge = !isIE && !!window.StyleMedia
  const isChrome = !!window.chrome && !!window.chrome.webstore
  const isWindows = navigator.platform.toLowerCase().indexOf('win') > -1
  const isMac = navigator.platform.toLowerCase().indexOf('mac') > -1

  return {
    opera: isOpera,
    firefox: isFirefox,
    safari: isSafari,
    ie: isIE,
    edge: isEdge,
    chrome: isChrome,
    windows: isWindows,
    mac: isMac
  }
}

export function getDomainWithoutSubdomain(url) {
  const urlParts = (url ?? window.location.origin).split('.')
  return urlParts.slice(-(urlParts.length === 4 ? 3 : 2)).join('.')
}
